import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DriverManagementDriversRequest, DriverManagementDriversResponse } from './driver-management-drivers.models';
import { IDriverManagement } from './models/driver-management-drivers.model';

@Injectable({ providedIn: 'root' })
export class DriverManagementDriversApiService {
  private options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };
  private _apiDriverManagement = EndpointConstants.ApiDriverManagement;

  constructor(private http: HttpClient) {}

  getDriverManagement(...args: string[]): Observable<IDriverManagement> {
    const url = this._apiDriverManagement.replace(/{(\d+)}/g, (match, index) => args[index] || '');
    return this.http.get<IDriverManagement>(url, this.options);
  }

  getDriverManagementDrivers(request: DriverManagementDriversRequest): Observable<DriverManagementDriversResponse> {
    return this.getDriverManagement(request.initialDate, request.endDate, request.plantIds.join(',')).pipe(
      map((response) => ({
        drivers: response?.drivers ?? [],
      })),
    );
  }
}
